__turbopack_context__.v({
  "challengeCell": "AdoptionSection-module__RN2BjG__challengeCell",
  "challengesSection": "AdoptionSection-module__RN2BjG__challengesSection",
  "headerChallenge": "AdoptionSection-module__RN2BjG__headerChallenge",
  "headerRow": "AdoptionSection-module__RN2BjG__headerRow",
  "headerSolution": "AdoptionSection-module__RN2BjG__headerSolution",
  "image": "AdoptionSection-module__RN2BjG__image",
  "imageWrapper": "AdoptionSection-module__RN2BjG__imageWrapper",
  "row": "AdoptionSection-module__RN2BjG__row",
  "sectionTitle": "AdoptionSection-module__RN2BjG__sectionTitle",
  "solutionCell": "AdoptionSection-module__RN2BjG__solutionCell",
  "subtitle": "AdoptionSection-module__RN2BjG__subtitle",
  "table": "AdoptionSection-module__RN2BjG__table",
  "tableTitle": "AdoptionSection-module__RN2BjG__tableTitle",
  "tableWrapper": "AdoptionSection-module__RN2BjG__tableWrapper",
  "titleOrange": "AdoptionSection-module__RN2BjG__titleOrange",
});
